import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const FAUNACLASS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FaunaClass.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.FaunaClass.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const FAUNACLASS_CONFIG = {
  entityName: 'FaunaClass',
  localizationKey: 'Planning::Entity.FaunaClass',
  fields: FAUNACLASS_FIELDS,
  permission: 'PlanningEnvironment.FaunaClasses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
